import { useEffect, useState } from "react";
import GaugeChart from "react-gauge-chart";
import jsPDF from "jspdf";
import ExperianScoreReportModal from "../EquifaxMenu/EquifaxCrScorev2/Equifaxscorev2Report";

const EquifaxCrScorev2 = ({ Equifaxv2Report }) => {

  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [submittedName, setSubmittedName] = useState("");
  const [submittedMobile, setSubmittedMobile] = useState("");
  const [creditScore, setCreditScore] = useState(0);
  const maxScore = 900;
  useEffect(() => {
    let creditScore = 0;
    let value = Equifaxv2Report?.data?.credit_score;
    if (value && !isNaN(value)) {
      creditScore = value;
    }
    setCreditScore(creditScore);
    setSubmittedName(Equifaxv2Report?.data?.name);
    setSubmittedMobile(Equifaxv2Report?.data?.mobile);
  }, [Equifaxv2Report]);
  const handleDownloadPDF = () => {
    const pdfContent = `
        <div>
            <h1>Equifax Credit Score Report</h1>
            <p>Name: ${
              Equifaxv2Report?.name ||
              Equifaxv2Error?.data?.name ||
              Equifaxv2Error?.error?.name
            }</p>
            <p>Mobile: ${
              Equifaxv2Report?.mobile ||
              Equifaxv2Error?.data?.mobile ||
              Equifaxv2Error?.error?.mobile
            }</p>
            <p>Score: ${creditScore}</p>
        </div>
    `;
    const pdf = new jsPDF();
    pdf.text(pdfContent, 10, 10);
    pdf.save("Equifax_Credit_Score_Report.pdf");
  };

  return (
    <>
      <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
        <span className="text-center font-bold md:text-xl">
          Hey{" "}
          {Equifaxv2Report?.data?.name ||
            Equifaxv2Error?.data?.name ||
            Equifaxv2Error?.error?.name}
          !
        </span>
        <h2 className="text-xl md:text-xl font-semibold text-center">
          Your Credit Score : {creditScore || "N/A"}
        </h2>

        <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
          <div className="w-full md:w-[400px] relative md:mt-10">
            <span
              className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70
    top-[60px] left-5 
    "
            >
              Poor
            </span>
            <span
              className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26
    left-[69px] top-[-7px] 
    "
            >
              Average
            </span>
            <span
              className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20
    left-[12rem] mt-[-9px] rotate-20
    "
            >
              Good
            </span>
            <span
              className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70
    ml-[16rem] mt-[3.5rem]
    "
            >
              Excellent
            </span>

            <GaugeChart
              id="gauge-chart1"
              nrOfLevels={3}
              percent={creditScore / maxScore} // Normalized value for gauge
              needleColor={"#00008b"}
              textColor={"transparent"} // Hides the percentage text
              needleBaseColor={"red"}
              arcsLength={[0.3, 0.3, 0.3, 0.3]}
              colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
            />
            <p
              className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] 
                    left-1/2 transform -translate-x-1/2"
            >
              {creditScore || "N/A"}
            </p>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <ul className="text-left text-sm md:text-base space-y-1 mt-4">
              <li>
                <span className="font-bold">No of Accounts: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.NoOfAccounts ?? "N/A"}
              </li>
              <li>
                <span className="font-bold">Active Accounts: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.NoOfActiveAccounts ?? "N/A"}
              </li>
              <li>
                <span className="font-bold">Total Balance Amount: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.TotalBalanceAmount ?? "N/A"}
              </li>
              <li>
                <span className="font-bold">Total Pass Due: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.TotalPastDue ?? "N/A"}
              </li>
              <li>
                <span className="font-bold">Recent Account: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.RecentAccount ?? "N/A"}
              </li>
              <li>
                <span className="font-bold">Oldest Account: </span>
                {Equifaxv2Report?.data?.credit_report?.CCRResponse
                  ?.CIRReportDataLst[0]?.CIRReportData?.RetailAccountsSummary
                  ?.OldestAccount ?? "N/A"}
              </li>
            </ul>

            <ExperianScoreReportModal
              isOpen={isModalOpen}
              onClose={() => setModalOpen(false)}
              Equifaxv2Report={Equifaxv2Report?.data?.credit_report}
              Equifaxv2Error={Equifaxv2Report?.data}
              submittedName={submittedName}
              submittedMobile={submittedMobile}
            />
            <div class="flex space-x-2 mt-4">
              <button
                onClick={() => setModalOpen(true)}
                class="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1"
              >
                View
              </button>
              <button
                class="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                onClick={handleDownloadPDF}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EquifaxCrScorev2;
